<template>
  <div ref="blockRef" class="mx-auto px-4 max-w-2xl">
    <div class="font-bold md:text-lg" data-gsap-target="title">
      {{ $statamic.trans('share') }}
    </div>

    <SocialShare :seo="meta?.seo" class="mt-4" />
  </div>
</template>

<script setup lang="ts">
import type { SocialShare } from '~/statamic/types/block';
import type { EntryMetaResponse } from '~/statamic/utils/formatEntryMeta';

defineProps<{
  meta?: EntryMetaResponse | null;
  block: SocialShare;
}>();

let ctx: gsap.Context | null;
const blockRef = ref();

onMounted(() => {
  ctx = useGsap.context((self) => {
    if (typeof self.selector !== 'function') return;

    const title = self.selector('[data-gsap-target="title"]');
    const links = self.selector('[data-gsap-target="link"]');

    const timeline = useGsap.timeline({
      scrollTrigger: {
        start: 'top bottom',
        end: 'bottom top',
        trigger: blockRef.value,
      },
    });

    if (title) {
      timeline.from(title, {
        x: -20,
        autoAlpha: 0,
      });
    }

    if (links?.length) {
      timeline.from(links, {
        x: 20,
        y: 20,
        stagger: 0.1,
        autoAlpha: 0,
      });
    }
  }, blockRef.value);
});

onUnmounted(() => {
  ctx?.revert();
});
</script>
